module.exports = function() {
  return new Worker(__webpack_public_path__ + "e364f123d0e96e5bdd06.worker.js");
};